import React from "react";
import {useQueryClient} from "react-query";
import ProgressBar from "../../../controls/ProgressBar";
import useVTripAllotmentTotals from "../../../services/trips/useVTripAllotmentTotals";

const barColors = {
  green: "rgba(0, 128, 0, 1)",
  red: "rgba(255, 0, 0, 1)",
  orange: "rgba(255, 128, 0, 1)",
  purple: "rgba(128, 0, 128, 1)",
}

const FlightAllotmentBar = (props) => {

  let maxPayload = props.maxPayload;
  const extraKeys = [props.tripUuid, props.tripLegUuid];
  const queryClient = useQueryClient();
  const allotmentTotals = useVTripAllotmentTotals({queryClient, extraKeys});

  const totals = {
    maxPayload: 0,
    cargoAllotments: 0,
    uldStacks: 0,
    bookedCargo: 0,
    expectedPayload: 0,
    actualCargo: 0
  }
  const allotmentRecords = [];

  if (allotmentTotals && Array.isArray(allotmentTotals.data) && allotmentTotals.data.length > 0) {
    allotmentTotals.data.forEach(record => {
      if (record.aoo !== "" && record.aod !== "") {
        allotmentRecords.push({...record, clientRecords: []});
        totals.cargoAllotments += record.totalAllotmentKg;
      }

      if (!maxPayload) {
        maxPayload = record.payload;
      }
    });
  }

  const completed = totals.cargoAllotments && !isNaN(totals.cargoAllotments) && maxPayload && maxPayload > 0 ? totals.cargoAllotments / maxPayload * 100 : 0;

  return(
    <ProgressBar completed={Number(completed).toLocaleString(undefined, {minimumFractionDigits: 1, maximumFractionDigits: 1})} backgroundColor={completed > 100 ? barColors.purple : completed < 50 ? barColors.red : completed < 75 ? barColors.orange : barColors.green}/>
  );
}

export default FlightAllotmentBar;
